import { InjectionToken } from '@angular/core';


export const MMU_FEATURE_FLAG_PREFIX = new InjectionToken<string>('FEATURE_FLAG_PREFIX', {
  providedIn: 'root',
  factory: (): string => 'feature_'
});
